import { render, staticRenderFns } from "./SurveyStep1.vue?vue&type=template&id=7512a6c6&scoped=true&"
import script from "./SurveyStep1.vue?vue&type=script&lang=js&"
export * from "./SurveyStep1.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep1.vue?vue&type=style&index=0&id=7512a6c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512a6c6",
  null
  
)

export default component.exports